/* eslint-disable spaced-comment */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { useSetupHook } from './hooks'
import { Button, Checkbox, Modal, Table, Input, Select, Space } from 'antd'
import { CheckboxGroupProps } from 'antd/lib/checkbox'
import RadioTabs from '../RadioTabs'
import { FormInstance } from 'antd/lib/form'
import {
  POST_EXPORT_DOWNLOAD_CUSTOMER_CATEGORY,
  POST_EXPORT_DOWNLOAD_CUSTOMER_BRAND,
  POST_EXPORT_DOWNLOAD_CUSTOMER_STANDARD_LIBRARY,
} from '@/api/reportApi'
import { isResponseCodeSuccess } from '@/tools/util'
import { message } from 'antd'
const { Search } = Input
const { Option } = Select

export interface Props extends CheckboxGroupProps {
  onDownloadTemplate?: () => void
  mode?: 'multiple' | 'single' // 新增 mode 参数，默认为 multiple
  form?: FormInstance
  productType?: string
  showDownloadTemplate?: boolean
}

export default function RelationProjectCheckGroup(props: Props) {
  const {
    onDownloadTemplate,
    value,
    mode = 'multiple',
    showDownloadTemplate = false,
    form,
    onChange,
    ...restPorps
  } = props
  const {
    state,
    handleCheckboxGroupChange,
    handleSingleSelectChange,
    openModal,
    handleCheckedChange,
    previousPage,
    nextPage,
    pagination,
    onSearch,
    disable,
    searchValue,
    handleChange,
  } = useSetupHook(props)
  const {
    relationProjectList,
    isOpenModal,
    checkedRadioKey,
    currentRadioDict,
    modalList,
    filteredPlatformList,
  } = state

  const columns = {
    类目信息: {
      listColumn: [
        {
          key: 'oneCode',
          dataIndex: 'oneCode',
          title: '一级类目编码',
        },
        {
          key: 'oneName',
          dataIndex: 'oneName',
          title: '一级类目',
        },
        {
          key: 'twoCode',
          dataIndex: 'twoCode',
          title: '二级类目编码',
        },
        {
          key: 'twoName',
          dataIndex: 'twoName',
          title: '二级类目',
        },
        {
          key: 'threeCode',
          dataIndex: 'threeCode',
          title: '三级类目编码',
        },
        {
          key: 'threeName',
          dataIndex: 'threeName',
          title: '三级类目',
        },
        {
          key: 'fourCode',
          dataIndex: 'fourCode',
          title: '四级类目编码',
        },
        {
          key: 'fourName',
          dataIndex: 'fourName',
          title: '四级类目',
        },
      ],
    },
    单位信息: {
      listColumn: [
        {
          key: 'unit',
          dataIndex: 'unit',
          title: '单位信息',
          width: '50%',
        },
        {
          key: 'name',
          dataIndex: 'name',
          title: '单位名称',
          width: '50%',
        },
      ],
    },
    品牌信息: {
      listColumn: [
        {
          key: 'brandCode',
          dataIndex: 'brandCode',
          title: '品牌编码',
          width: '50%',
        },
        {
          key: 'fullName',
          dataIndex: 'fullName',
          title: '品牌名称',
          width: '50%',
        },
      ],
    },
  }

  const handleDownload = async (
    downloadType: 'category' | 'brand' | 'standardLibrary',
  ) => {
    const platformCode = (value as any)?.[0]?.platformCode
    if (!platformCode) {
      message.warning('请先选择平台')
      return
    }
    const downloadMap = {
      category: POST_EXPORT_DOWNLOAD_CUSTOMER_CATEGORY,
      brand: POST_EXPORT_DOWNLOAD_CUSTOMER_BRAND,
      standardLibrary: POST_EXPORT_DOWNLOAD_CUSTOMER_STANDARD_LIBRARY,
    }
    const res = await downloadMap[downloadType]({ platformCode })
    if (isResponseCodeSuccess(res.code)) {
      message.success('已转移至任务中心执行')
    }
  }
  return (
    <div>
      <div>
        {mode === 'multiple' ? (
          <Checkbox.Group
            {...restPorps}
            value={
              value?.map((item: any) => item?.platformCode || item?.code) ?? []
            }
            onChange={handleCheckboxGroupChange}
            options={filteredPlatformList.map((item) => {
              return {
                label: item.name,
                value: item.code,
              }
            })}
          ></Checkbox.Group>
        ) : (
          <Select
            showSearch
            placeholder="请选择关联项目"
            optionFilterProp="children"
            value={(value as any)?.[0]?.code || undefined}
            onChange={handleSingleSelectChange}
            filterOption={(input, option) =>
              (option?.children as unknown as string)
                ?.toLowerCase()
                .includes(input.toLowerCase())
            }
            style={{ width: '300px' }}
          >
            {filteredPlatformList.map((item) => (
              <Option key={item.code} value={item.code}>
                {item.name}
              </Option>
            ))}
          </Select>
        )}
      </div>
      <Button type="link" onClick={() => openModal(true)}>
        预览品牌/单位/类目参考信息
      </Button>
      <br />
      <Space>
        <Button
          type="link"
          // disabled={value ? false : true}
          onClick={onDownloadTemplate}
        >
          下载导入模板
        </Button>
        {showDownloadTemplate && (
          <Button
            type="link"
            size="small"
            onClick={() => handleDownload('category')}
          >
            客户分类下载
          </Button>
        )}
        {showDownloadTemplate && (
          <Button
            type="link"
            size="small"
            onClick={() => handleDownload('brand')}
          >
            客户品牌下载
          </Button>
        )}
        {showDownloadTemplate && (
          <Button
            type="link"
            size="small"
            onClick={() => handleDownload('standardLibrary')}
          >
            客户标准库下载
          </Button>
        )}
      </Space>
      <Modal
        title="文件预览"
        width={'1200px'}
        open={isOpenModal}
        onCancel={() => openModal(false)}
        footer={null}
      >
        <RadioTabs
          defaultKey={checkedRadioKey}
          radioItemDict={currentRadioDict}
          onChange={handleCheckedChange}
        />
        <div style={{ marginTop: '12px' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '12px',
            }}
          >
            <span style={{ fontWeight: '600', fontSize: '16px' }}>
              {checkedRadioKey === '类目信息'
                ? '四级类目名称：'
                : checkedRadioKey === '单位信息'
                  ? '单位名称：'
                  : '品牌名称：'}
            </span>
            <Search
              value={searchValue}
              allowClear
              size="large"
              placeholder="输入关键字查询"
              onChange={(e) => handleChange(e)}
              onSearch={onSearch}
              style={{ width: 350 }}
            />
          </div>

          <Table
            //@ts-ignore
            columns={columns[checkedRadioKey].listColumn}
            dataSource={modalList}
            pagination={false}
          />
          <div style={{ textAlign: 'end', paddingTop: '10px' }}>
            <Button
              onClick={() => previousPage()}
              disabled={pagination?.current === 1}
            >
              {'<'}上一页
            </Button>
            <Button
              onClick={() => nextPage()}
              style={{ marginLeft: '6px' }}
              disabled={disable}
            >
              下一页{'>'}
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  )
}
/* eslint-disable spaced-comment */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { useSetupHook } from './hooks'
import { Button, Checkbox, Modal, Table, Input, Select, Space } from 'antd'
import { CheckboxGroupProps } from 'antd/lib/checkbox'
import RadioTabs from '../RadioTabs'
import { FormInstance } from 'antd/lib/form'
import {
  POST_EXPORT_DOWNLOAD_CUSTOMER_CATEGORY,
  POST_EXPORT_DOWNLOAD_CUSTOMER_BRAND,
  POST_EXPORT_DOWNLOAD_CUSTOMER_STANDARD_LIBRARY,
} from '@/api/reportApi'
import { isResponseCodeSuccess } from '@/tools/util'
import { message } from 'antd'
const { Search } = Input
const { Option } = Select

export interface Props extends CheckboxGroupProps {
  onDownloadTemplate?: () => void
  mode?: 'multiple' | 'single' // 新增 mode 参数，默认为 multiple
  form?: FormInstance
  productType?: string
  showDownloadTemplate?: boolean
}

export default function RelationProjectCheckGroup(props: Props) {
  const {
    onDownloadTemplate,
    value,
    mode = 'multiple',
    showDownloadTemplate = false,
    form,
    onChange,
    ...restPorps
  } = props
  const {
    state,
    handleCheckboxGroupChange,
    handleSingleSelectChange,
    openModal,
    handleCheckedChange,
    previousPage,
    nextPage,
    pagination,
    onSearch,
    disable,
    searchValue,
    handleChange,
  } = useSetupHook(props)
  const {
    relationProjectList,
    isOpenModal,
    checkedRadioKey,
    currentRadioDict,
    modalList,
    filteredPlatformList,
  } = state

  const columns = {
    类目信息: {
      listColumn: [
        {
          key: 'oneCode',
          dataIndex: 'oneCode',
          title: '一级类目编码',
        },
        {
          key: 'oneName',
          dataIndex: 'oneName',
          title: '一级类目',
        },
        {
          key: 'twoCode',
          dataIndex: 'twoCode',
          title: '二级类目编码',
        },
        {
          key: 'twoName',
          dataIndex: 'twoName',
          title: '二级类目',
        },
        {
          key: 'threeCode',
          dataIndex: 'threeCode',
          title: '三级类目编码',
        },
        {
          key: 'threeName',
          dataIndex: 'threeName',
          title: '三级类目',
        },
        {
          key: 'fourCode',
          dataIndex: 'fourCode',
          title: '四级类目编码',
        },
        {
          key: 'fourName',
          dataIndex: 'fourName',
          title: '四级类目',
        },
      ],
    },
    单位信息: {
      listColumn: [
        {
          key: 'unit',
          dataIndex: 'unit',
          title: '单位信息',
          width: '50%',
        },
        {
          key: 'name',
          dataIndex: 'name',
          title: '单位名称',
          width: '50%',
        },
      ],
    },
    品牌信息: {
      listColumn: [
        {
          key: 'brandCode',
          dataIndex: 'brandCode',
          title: '品牌编码',
          width: '50%',
        },
        {
          key: 'fullName',
          dataIndex: 'fullName',
          title: '品牌名称',
          width: '50%',
        },
      ],
    },
  }

  const handleDownload = async (
    downloadType: 'category' | 'brand' | 'standardLibrary',
  ) => {
    const platformCode = (value as any)?.[0]?.platformCode
    if (!platformCode) {
      message.warning('请先选择平台')
      return
    }
    const downloadMap = {
      category: POST_EXPORT_DOWNLOAD_CUSTOMER_CATEGORY,
      brand: POST_EXPORT_DOWNLOAD_CUSTOMER_BRAND,
      standardLibrary: POST_EXPORT_DOWNLOAD_CUSTOMER_STANDARD_LIBRARY,
    }
    const res = await downloadMap[downloadType]({ platformCode })
    if (isResponseCodeSuccess(res.code)) {
      message.success('已转移至任务中心执行')
    }
  }
  return (
    <div>
      <div>
        {mode === 'multiple' ? (
          <Checkbox.Group
            {...restPorps}
            value={
              value?.map((item: any) => item?.platformCode || item?.code) ?? []
            }
            onChange={handleCheckboxGroupChange}
            options={filteredPlatformList.map((item) => {
              return {
                label: item.name,
                value: item.code,
              }
            })}
          ></Checkbox.Group>
        ) : (
          <Select
            showSearch
            placeholder="请选择关联项目"
            optionFilterProp="children"
            value={(value as any)?.[0]?.code || undefined}
            onChange={handleSingleSelectChange}
            filterOption={(input, option) =>
              (option?.children as unknown as string)
                ?.toLowerCase()
                .includes(input.toLowerCase())
            }
            style={{ width: '300px' }}
          >
            {filteredPlatformList.map((item) => (
              <Option key={item.code} value={item.code}>
                {item.name}
              </Option>
            ))}
          </Select>
        )}
      </div>
      <Button type="link" onClick={() => openModal(true)}>
        预览品牌/单位/类目参考信息
      </Button>
      <br />
      <Space>
        <Button
          type="link"
          // disabled={value ? false : true}
          onClick={onDownloadTemplate}
        >
          下载导入模板
        </Button>
        {showDownloadTemplate && (
          <Button
            type="link"
            size="small"
            onClick={() => handleDownload('category')}
          >
            客户分类下载
          </Button>
        )}
        {showDownloadTemplate && (
          <Button
            type="link"
            size="small"
            onClick={() => handleDownload('brand')}
          >
            客户品牌下载
          </Button>
        )}
        {showDownloadTemplate && (
          <Button
            type="link"
            size="small"
            onClick={() => handleDownload('standardLibrary')}
          >
            客户标准库下载
          </Button>
        )}
      </Space>
      <Modal
        title="文件预览"
        width={'1200px'}
        open={isOpenModal}
        onCancel={() => openModal(false)}
        footer={null}
      >
        <RadioTabs
          defaultKey={checkedRadioKey}
          radioItemDict={currentRadioDict}
          onChange={handleCheckedChange}
        />
        <div style={{ marginTop: '12px' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '12px',
            }}
          >
            <span style={{ fontWeight: '600', fontSize: '16px' }}>
              {checkedRadioKey === '类目信息'
                ? '四级类目名称：'
                : checkedRadioKey === '单位信息'
                  ? '单位名称：'
                  : '品牌名称：'}
            </span>
            <Search
              value={searchValue}
              allowClear
              size="large"
              placeholder="输入关键字查询"
              onChange={(e) => handleChange(e)}
              onSearch={onSearch}
              style={{ width: 350 }}
            />
          </div>

          <Table
            //@ts-ignore
            columns={columns[checkedRadioKey].listColumn}
            dataSource={modalList}
            pagination={false}
          />
          <div style={{ textAlign: 'end', paddingTop: '10px' }}>
            <Button
              onClick={() => previousPage()}
              disabled={pagination?.current === 1}
            >
              {'<'}上一页
            </Button>
            <Button
              onClick={() => nextPage()}
              style={{ marginLeft: '6px' }}
              disabled={disable}
            >
              下一页{'>'}
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  )
}
